import React, {useState} from 'react'
import PropTypes from 'prop-types'
import style from './style.module.scss'
import formatCurrency from '../../../utils'

export const BarChart = (props) => {
  
  const maxJurosBarHeight = 26
  const maxJurosBarHeightMobile = 34
  const investidoBarHeight = 92
  const investidoBarHeightMobile = 118

  function getJurosBarHeight(maiorJuros, juros){
    let heightReturn = (window.screen.width > 768)?maxJurosBarHeight:maxJurosBarHeightMobile
    if(maiorJuros > 0){
      heightReturn = heightReturn * (juros/maiorJuros)
    }
    return `${heightReturn}px`
  }

  function calcularRentabilidadeReal(taxa, inflacao){
    return ((1 + taxa)/(1+inflacao)-1)*100
  }

  function calculaValorFinal(valorAcumulado, alImposto, inflacao){
    let valorNominal = valorAcumulado - ((valorAcumulado - props.investido) * alImposto)
    /*if(props.type === 'real'){
      return valorNominal + (valorNominal*inflacao/100)
    }*/
    return valorNominal
  }

  function criaGrafico(){
    let investido = props.investido
    let acumulado = Object.assign([], props.acumulado)
    let maiorJuros = Math.max.apply(null, acumulado.map(e=>e.value - investido))
    let chart = []
    let columns = []
    let rowValores = []
    for (let coluna = 0; coluna < acumulado.length; coluna++) {
      let row = []
      // Adiciona barra de juros
      if(maiorJuros === 0){
        row.push(<div key={`barChart-juros-${coluna}`} style={{height: getJurosBarHeight(maiorJuros, (acumulado[coluna].value - investido))}}></div>)
      } else {
        row.push(<div key={`barChart-juros-${coluna}`} className={style.jurosBar} style={{height: getJurosBarHeight(maiorJuros, (acumulado[coluna].value - investido))}}></div>)
      }
      // Adiciona linha
      row.push(<div key={`barChart-linha-${coluna}`} className={style.chartLine}></div>)
      // Adiciona barra de valor investido
      row.push(<div key={`barChart-investido-${coluna}`} className={style.investidoBar} style={{height: `${(window.screen.width > 768)?investidoBarHeight:investidoBarHeightMobile}px`}}></div>)
      // Adiciona linha
      row.push(<div key={`barChart-linha-2-${coluna}`} className={style.chartLine}></div>)
      // Adiciona Linha com os valores finais
      rowValores.push(<div key={`barChart-valor-final${coluna}`} className={style.chartDataValue}>R$ {formatCurrency(calculaValorFinal(acumulado[coluna].value, acumulado[coluna].alImposto/100, calcularRentabilidadeReal(((acumulado[coluna].value - investido)/investido), acumulado[coluna].inflacao/100)))}</div>)
      columns.push(<div key={`barChart-coluna-${coluna}`} className={style.chartColumn}>{row}</div>)
    }
    chart.push(
      <div key={'barChart'} className={style.chart}>
        <div className={style.rowLegend}>
          <div className={`${style.chartColumnBold} ${style.chartDataWhite}`} style={{maxHeight: getJurosBarHeight(maiorJuros, maiorJuros)}}>Juros</div>
          <div className={style.chartColumnInves} style={{height: `${(window.screen.width > 768)?investidoBarHeight:investidoBarHeightMobile}px`}}>
            <div>Investido</div>
            <div>R$ {formatCurrency(investido)}</div>
          </div>
          <div className={`${style.chartColumnBold} ${style.chartDataWhite}`}>Valor Total Nominal</div>
        </div>
        <div style={{flex: 1}}>
          <div className={style.chartColumns}>
            {columns}
          </div>
          <div className={style.chartColumns}>
            {rowValores}
          </div>
        </div>
      </div>
    )
    return chart
  }

  return (
      <div className={style.main}>
          {criaGrafico()}
      </div>
  )
}
